var exports = {
  "v": "ProviderLogo__EgfDhn",
};

module.exports = exports;
